export const getTableStyles = (theme) => ({
  muiTableContainerProps: {
    sx: {
      maxHeight: 'none',
    },
  },
  muiTablePaperProps: {
    elevation: 0,
    sx: {
      borderRadius: 0,
      border: 'none',
      boxShadow: theme.shadows[1],
    },
  },
  muiTableHeadCellProps: {
    sx: {
      fontWeight: 600,
      fontSize: '0.875rem',
      backgroundColor: theme.palette.grey[100],
      borderBottom: `2px solid ${theme.palette.divider}`,
      padding: theme.spacing(1, 1.5),
      '&:hover': {
        backgroundColor: theme.palette.grey[200],
      },
    },
  },
  muiTopToolbarProps: {
    sx: {
      backgroundColor: theme.palette.background.paper,
      borderBottom: `1px solid ${theme.palette.divider}`,
      minHeight: 48,
    },
  },
  muiBottomToolbarProps: {
    sx: {
      backgroundColor: theme.palette.background.paper,
      borderTop: `1px solid ${theme.palette.divider}`,
    },
  },
  muiTableProps: {
    sx: {
      tableLayout: 'auto',
    },
  },
});

export const getRowStyles = (theme, isEditing) => ({
  sx: {
    backgroundColor: theme.palette.background.paper,
    height: 40,
    transition: 'background-color 0.2s ease',
    '&:hover': {
      backgroundColor: isEditing
        ? theme.palette.action.selected
        : theme.palette.action.hover,
    },
    '&:nth-of-type(odd)': {
      backgroundColor: isEditing
        ? theme.palette.action.selected
        : theme.palette.action.hover,
    },
    ...(isEditing && {
      backgroundColor: theme.palette.action.selected,
    }),
  },
});

export const getCellStyles = (theme) => ({
  fontSize: '0.875rem',
  padding: theme.spacing(0.5, 1.5),
  borderColor: theme.palette.divider,
});

export const tableFeatures = {
  enableEditing: true,
  editDisplayMode: 'custom',
  enableStickyHeader: false,
  enableStickyFooter: false,
  enableColumnFilters: true,
  enableGlobalFilter: true,
  enableSorting: true,
  enablePagination: true,
  enableDensityToggle: false,
  enableFullScreenToggle: false,
  enableColumnActions: false,
  enableColumnDragging: false,
  positionActionsColumn: 'last',
};

export const initialTableState = {
  columnVisibility: { _id: false },
  pagination: { pageSize: 25, pageIndex: 0 },
  density: 'compact',
};
